import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap'
import React from 'react';
import * as styles from '../SubmitButton/_SubmitButton.scss'

const SubmitButtonForApproval = ({
  buttonText
  , isValid
  , isSubmitting
  , onClick
  , isTermsAccepted
  , isSubmitted
}) => (
  <Button type='submit'
    className={styles['submit-button']}
    variant={'primary'}
    size={'lg'}
    onClick={onClick}
    disabled={!isValid || isSubmitting || !isTermsAccepted || isSubmitted}>
    <span>{buttonText}</span>
  </Button>)

SubmitButtonForApproval.propTypes = {
  buttonText: PropTypes.string.isRequired,
  isValid: PropTypes.bool.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  isTermsAccepted: PropTypes.bool.isRequired,
  isSubmitted: PropTypes.bool.isRequired
}

export default SubmitButtonForApproval
